import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { IssueProductLogo } from './-components/IssueProductLogo';
export const Route = createFileRoute('/_stacktrace/issues/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  const {
    t: tStacktrace
  } = useTranslation(stacktraceNS);
  useDocumentTitle(tStacktrace('issues.title'));

  /**
   * 概要は 2026-05-25 Phase G-1/G-2 で enable 済 (playbook §3.15 の
   * lazy 分離回避パターンで cascade 発生せず)。
   * エンハンス要望 / 設定 は将来追加予定のため disabled。
   * `to` は LinkProps の型上必須なので未実装パスを `as never` でキャスト。
   */
  const tabs = [{
    to: '/issues/overview',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues',
    children: tStacktrace('issues.list.tabLabel'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues/enhancements' as never,
    children: t('common.list.enhancements'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues/alerts' as never,
    children: t('common.list.alerts'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues/operation-activity' as never,
    children: t('common.list.operationActivity'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues/rules-and-policy' as never,
    children: t('common.list.configuration'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/issues/settings' as never,
    children: t('common.list.settings'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={IssueProductLogo} name={tStacktrace('issues.title')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}